
const state = () => ({
  isAuthenticated: false,
  isExpanded: localStorage.getItem('is_expanded') === 'true', // bolean values in localStorage is saved as string, therefor this control
  isHidden: localStorage.getItem('is_hidden') === 'true', // bolean values in localStorage is saved as string, therefor this control
  pageHeader: ''
})

// getters
const getters = {
}

// actions
const actions = {
  async setLogin ({ state, commit }) {
    commit('setAuth')
  }
}

const mutations = {
  setAuth (state) {
    state.isAuthenticated = true
  },
  setApiVersion (state, apiVersion) {
    state.apiVersion = apiVersion
  },
  toggleIsExpanded (state) {
    state.isExpanded = !state.isExpanded
    localStorage.setItem('is_expanded', state.isExpanded)
  },
  setIsExpanded (state, boolValue) {
    state.isExpanded = boolValue
    localStorage.setItem('is_expanded', state.isExpanded)
  },
  setIsHidden (state, boolValue) {
    state.isHidden = boolValue
    localStorage.setItem('is_hidden', state.isHidden)
  },
  toggleIsHidden (state) {
    state.isHidden = !state.isHidden
    localStorage.setItem('is_hidden', state.isHidden)
  },
  sidebarLogOut () {
    state.isAuthenticated = false
  },
  setCurrentPageHeaderText (state, text) {
    state.pageHeader = text
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
